window.$ = window.jQuery = require('jquery');
require('objectFitPolyfill');

$(window).on("scroll", function () {
  var s = $(this).scrollTop();
  var m = 150;
  if(s > m) {
    $('.footerScroll').fadeIn('slow');
  } else if(s < m) {
    $('.footerScroll').fadeOut('slow');
  }
});


//スムーズスクロール
$('a[href^="#"]').on('click', function() {
var speed = 500;
var href= $(this).attr('href');
var target = $(href == '#' || href == '' ? 'html' : href);
var position = target.offset().top;
$('html, body').animate({scrollTop: position}, speed, 'swing');
return false;
});


//自動電話番号リンク
var ua = navigator.userAgent;
if(ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0) {
  $('.telLink').each(function() {
    var str = $(this).text();
    $(this).html($('<a>').attr('href', 'tel:' + str.replace(/-/g, '')).append(str + '</a>'));
  });
}



//menu
$(function () {
  $('.headButton').on('click', function() {
    $('.navWrap').stop().slideToggle();
    $(this).stop().toggleClass('on');
  });
});


$(window).on('load resize', function(){
  //var w = $(window).width();
  var w = window.innerWidth;
  var x = 960;
  if (w < x) {
//画面サイズが768px未満のときの処理

    $('.navUnder').css('padding','0');
    $('.navUnder').css('height','auto');


    $('.navItem').off();
    $('.navItem').off();


    $('.navItem').on('click', function() {
      $(this).children('.navUnder').slideToggle('');
    });

  } else {
//それ以外のときの処理

    $('.navUnder').css('padding','60px 15px 65px');

    //event
    $('.navItem').mouseover(function() {
        $(this).children('.navUnder').stop().slideDown();
    });
    $('.navItem').mouseout(function() {
        $(this).children('.navUnder').stop().slideUp();
    });
  }
});



//オブジェクトフィット
objectFitPolyfill($('.objImg'));



